// extracted by mini-css-extract-plugin
export default {"creationDate":"Task_creationDate__zT1dC","clientDataContainer":"Task_clientDataContainer__K9JB2"};